import React from "react";
import { MessageBar as MessageBarComponent } from "@fluentui/react";
import { IMessageBarProps } from "../interfaces/IMessageBarProps";

export const MessageBar: React.FC<IMessageBarProps> = (props) => {
    return <MessageBarComponent>
        {props.getLocalizedString("saveRecord")}
    </MessageBarComponent>;
};